<template>
  <div class="content">
    <div class="title">
      <span>查处情况</span>
      <btnauth custype="apply" :year="year" :quarter="quarter">
        <!-- <van-button
          v-if="inveDetailList.length > 0 && isSubmited == 0 && addAuth && addAuth === 'OPERATION01'"
          type="primary"
          size="small"
          @click="addbtnClick"
        >+ 新增</van-button> -->
        <!-- <addbtnplus  v-if="inveDetailList.length > 0 && isSubmited == 0 && addAuth && addAuth === 'OPERATION01' && (datauserId === userId || !datauserId) "
                :width="'70px'" :height="'30px'"  @click="addbtnClick">
        </addbtnplus> -->
      </btnauth>
    </div>
    <div class="child-item">
      <div class="item-detail" v-if="hasDetail">
        <inveChilddetail
          :detailList="inveDetailList"
          :deleteAuth="deleteAuth"
          :updateAuth="updateAuth"
          :submitAuth="submitAuth"
          :isSubmited="isSubmited"
          :year="year"
          :quarter="quarter"
          :datauserId="datauserId"
          @addbtnClick="addbtnClick"
          @onDel="onDel"
          @updataConfirm="updataConfirm"
        ></inveChilddetail>
      </div>
      <!-- <div class="item" v-if=" inveDetailList && inveDetailList.length <= 0 && isSubmited == 0 && addAuth && addAuth === 'OPERATION01' && (datauserId === userId || !datauserId)  ">
        <btnauth custype="apply" :year="year" :quarter="quarter">
          <addbtnnomarl @addbtnClick="addbtnClick"></addbtnnomarl>
        </btnauth>
      </div> -->
    </div>
     <!-- <addbtnnomarl @addbtnClick="addbtnClick"></addbtnnomarl> -->
  </div>
</template>
<script>
import addbtnnomarl from "./addBtn_nomarl";
import inveChilddetail from "./inveChilddetail";
import btnauth from "./btnauth";
import addbtnplus from './addBtn_plus';
import commonAPI from "@/utils/common";
export default {
  name: "investigateDetail",
  props: {
    hasDetail: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    inveDetailList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    addAuth: {
      type: String,
      default: () => {
        return "";
      },
    },
    deleteAuth: {
      type: String,
      default: () => {
        return "";
      },
    },
    updateAuth: {
      type: String,
      default: () => {
        return "";
      },
    },
    submitAuth: {
      type: String,
      default: () => {
        return "";
      },
    },
    isSubmited: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    year: {
      type: [String,Number],
      default: () => {
        return "";
      },
    },
    quarter: {
      type: [String,Number],
      default: () => {
        return "";
      },
    },
    datauserId:{
      type: String,
      default:()=>{
        return "";
      }
    }
  },
  components: {
    addbtnnomarl,
    inveChilddetail,
    btnauth,
    addbtnplus
  },
  data() {
    return {
      userId: commonAPI.getUserId(),
    };
  },
  methods: {
    /**
     * @description: 点击编辑时跳转到新增和编辑页面
     * code { String } 附件关联的 code
     */
    addbtnClick(code) {
      this.$emit("addbtnClick", code);
    },
    /**
     * @description: 点击删除
     * element { Object } 点击的当前对象
     */
    onDel(element) {
      this.$emit("delFile", element);
    },
    /** 确认上报 **/
    updataConfirm() {
      this.$emit("updataConfirm");
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  margin-top: 24px;
  background-color: #FBFBFB;
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    span {
      flex: 1;
    }
  }
  .child-item {
    margin-top: 12px;
    .item {
      height: 78px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 3px;

      display: flex;
      justify-content: center;
      align-items: center;
    }
    // .item-detail {
    // }
  }
}
</style>
